import { Route, Routes } from 'react-router-dom';

import { DefaultLayout2 } from '@web/app/shared/components/default-layout';

import { AccessKeysPage } from '../pages';

export const AccessKeysRoutes = () => {
    return (
        <Routes>
            <Route element={<DefaultLayout2 />}>
                <Route path="/" element={<AccessKeysPage />} />
                <Route path="/:keyId" element={<AccessKeysPage />} />
            </Route>
        </Routes>
    );
};
